let formatter: Intl.NumberFormat;

export const setFormatter = (culture: string = 'en-US', currency: string = 'USD') => {
	formatter = new Intl.NumberFormat(culture, {
		style: 'currency',
		currency,
		// minimumFractionDigits: 2,
		compactDisplay: 'short'
	});
	return formatter;
};

export const formatCurrency = (number: number) => formatter.format(number);

export const formatCurrencySymbol = (number: number) => {
	const converted = formatCurrency(number);
	const currencySymbol = converted.replace(/[\d,.]/g, '').trim();

	return {
		symbol: currencySymbol,
		value: converted.slice(currencySymbol.length > 1 ? 0 : converted.split(' ').length > 1 ? 0 : 1)
	};
};
